import React from "react";

type Props = {
  title: string;
  value: string | JSX.Element;
  includeColon?: boolean;
  valueBold?: boolean;
  className?: string;
  titleClassName?: string;
  valueClassName?: string;
};

const InfoItemInline = ({
  title,
  value,
  includeColon = false,
  valueBold = true,
  className,
  titleClassName,
  valueClassName
}: Props) => {
  // helpers
  const valueClasses = [valueBold ? "font-weight-bold" : null, valueClassName]
    .filter(Boolean)
    .join(" ") || undefined;

  // render
  return (
    <div
      className={`d-flex justify-content-between${
        className ? ` ${className}` : ""
      }`}
    >
      <div className={`text-muted${titleClassName ? ` ${titleClassName}` : ""}`}>
        {title}
        {includeColon ? ":" : ""}
      </div>
      <div className={valueClasses}>{value}</div>
    </div>
  );
};

export default InfoItemInline;
